const TYPE_SPECIES = {
    key: 1,
    label: "Species"
};
const TYPE_WEIGHT = {
    key: 2,
    label: "Weight"
};
const TYPE_AGE = {
    key: 3,
    label: "Age"
};
const RULE_TYPES = [TYPE_SPECIES, TYPE_WEIGHT, TYPE_AGE];
const RULE_TYPES_OBJECT = {
    [TYPE_SPECIES.key]: TYPE_SPECIES,
    [TYPE_WEIGHT.key]: TYPE_WEIGHT,
    [TYPE_AGE.key]: TYPE_AGE
};
export default {
    TYPE_SPECIES,
    RULE_TYPES_OBJECT,
    TYPE_WEIGHT,
    TYPE_AGE,
    RULE_TYPES
};
